<template>
  <div>
    <gift-card-spec-info
      :giftCardSpecInfo="giftCardSpecInfo"
    ></gift-card-spec-info>

    <!--search form-->
    <el-form
      ref="formRef"
      :model="searchForm"
      style="width:100%"
      :inline="true"
      :label-position="'right'"
      size="mini"
    >
      <el-form-item label="卡号">
        <el-input v-model="searchForm.cardNo" clearable></el-input>
      </el-form-item>

      <el-form-item label="会员昵称/手机号">
        <el-input v-model="searchForm.keyword" clearable></el-input>
      </el-form-item>
      <el-form-item label="购买时间">
        <el-date-picker
          v-model="searchForm.buyTimeStart"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        ~
        <el-date-picker
          v-model="searchForm.buyTimeEnd"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="激活时间">
        <el-date-picker
          v-model="searchForm.activeTimeStart"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        ~
        <el-date-picker
          v-model="searchForm.activeTimeEnd"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="状态">
        <el-select v-model="searchForm.status" clearable filterable>
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="success" @click="loadPage(1)">查询</el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button type="success" @click="handleAdd">新增</el-button>
      </el-form-item> -->
    </el-form>

    <!--buttons-->
    <div style="margin-bottom: 10px" class="table-btns">
      <div class="rl">
        <el-button size="mini" @click="handleGenerate">生成礼品卡</el-button>
        <el-button size="mini" @click="handleShowPwd">展示卡密</el-button>
      </div>
      <div class="rl">
        <el-button size="mini" @click="downLoad.exportExcel('tableId')"
          >导出</el-button
        >
      </div>
    </div>
    <!--table-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      size="mini"
      v-loading="loading"
      id="tableId"
      :key="tableKey"
    >
      <el-table-column prop="cardNo" label="卡号" align="center">
      </el-table-column>
      <el-table-column label="卡密" align="center" :key="pwdKey">
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            size="mini"
            @click="handleShow(scope.$index, scope.row)"
            v-if="!scope.row.showPwd"
          >
            点击显示密码</el-link
          >
          <span v-else>{{ scope.row.cardPwd }}</span>
        </template>
      </el-table-column>
      <el-table-column label="会员信息" align="center">
        <template slot-scope="scope">
          <span
            >{{ scope.row.subscriberName }}/{{
              scope.row.subscriberPhone
            }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="购买时间" prop="buyTime" align="center">
      </el-table-column>
      <el-table-column label="激活时间" prop="activeTime" align="center">
      </el-table-column>
      <el-table-column label="过期时间" prop="expiredTime" align="center">
      </el-table-column>
      <el-table-column label="卡片面值" prop="amount" align="center">
      </el-table-column>
      <el-table-column label="购买价格" prop="price" align="center">
      </el-table-column>
      <el-table-column label="余额" prop="balance" align="center">
      </el-table-column>
      <el-table-column label="状态" prop="statusName" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            size="mini"
            @click="handleDetail(scope.$index, scope.row)"
            >查看</el-link
          >
          <el-divider
            v-if="showGive(scope.row)"
            direction="vertical"
          ></el-divider>
          <!--link链接-->
          <el-link
            type="primary"
            :underline="false"
            size="mini"
            v-if="showGive(scope.row)"
            @click="handleGive(scope.$index, scope.row)"
            >发放</el-link
          >
          <el-divider
            direction="vertical"
            v-if="showRecycle(scope.row)"
          ></el-divider>
          <el-link
            type="primary"
            :underline="false"
            size="mini"
            @click="handleRecycle(scope.$index, scope.row)"
            v-if="showRecycle(scope.row)"
            >回收</el-link
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    >
    </el-pagination>

    <gift-card-record-generate
      ref="generateRef"
      @refresh="loadPage"
    ></gift-card-record-generate>

    <gift-card-record-info
      ref="infoRef"
      :giftCardInfo="currentGiftRecord"
      :drawerVisible.sync="recordInfoVisible"
      @close="recordInfoVisible = false"
    ></gift-card-record-info>

    <gift-card-give ref="giveRef" @refresh="loadPage"></gift-card-give>

    <gift-card-recycling
      ref="recyclingRef"
      @refresh="loadPage"
    ></gift-card-recycling>
  </div>
</template>
<script>
import {
  giftCardRecordStatusApi,
  giftCardSpecInfo,
  giftCardRecordPage
} from "@/api/giftCard";
import GiftCardSpecInfo from "./components/specInfo.vue";
import GiftCardRecordGenerate from "./components/generateCard.vue";
import GiftCardRecordInfo from "./components/infoRecord.vue";
import GiftCardGive from "./components/giveGiftCard.vue";
import GiftCardRecycling from "./components/recyclingGiftCard.vue";
export default {
  name: "BizGiftCardRecord",
  components: {
    GiftCardSpecInfo,
    GiftCardRecordGenerate,
    GiftCardRecordInfo,
    GiftCardGive,
    GiftCardRecycling
  },
  computed: {
    showGive() {
      return function(v) {
        return !v.subscriberId && v.cardType == 1;
      };
    },
    showRecycle() {
      return function(v) {
        return v.status != 6 && v.status != 4;
      };
    }
  },
  data() {
    return {
      giftCardSpecId: "",
      giftCardSpecInfo: {},
      statusOptions: [],
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      pwdKey: Math.random(),
      tableKey: Math.random(),
      tableData: [],
      loading: false,

      currentGiftRecord: {},
      recordInfoVisible: false
    };
  },
  created() {
    this.loadStatusOptions();
  },
  mounted() {
    this.loadPage(1);
  },
  watch: {
    "$route.query.id": {
      immediate: true,
      handler(nv, ov) {
        if (nv) {
          this.giftCardSpecId = this.$route.query.id;
          this.getGiftCardSpecInfo();
        }
      }
    }
  },
  methods: {
    loadStatusOptions() {
      giftCardRecordStatusApi().then(res => {
        if (res.data.status == 100) {
          this.statusOptions = res.data.results;
        }
      });
    },
    getGiftCardSpecInfo() {
      giftCardSpecInfo(this.giftCardSpecId).then(res => {
        if (res.data.status == 100) {
          this.giftCardSpecInfo = res.data.results;
        }
      });
    },
    loadPage(page) {
      if (page) {
        this.searchForm.pageNum = page;
      }
      this.searchForm.specId = this.giftCardSpecId;
      this.loading = true;
      giftCardRecordPage(this.searchForm)
        .then(res => {
          this.loading = false;
          if (res.data.status == 100) {
            this.searchForm.total = res.data.results.total;
            this.tableData = res.data.results.list;
            this.tableData.forEach(item => {
              item.showPwd = false;
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.loadPage();
    },
    handleCurrentChange(page) {
      this.searchForm.pageNum = page;
      this.loadPage();
    },
    handleGenerate() {
      this.$refs.generateRef.open(this.giftCardSpecInfo);
    },
    handleShow(index, row) {
      row.showPwd = !row.showPwd;
      this.pwdKey = Math.random();
    },
    handleShowPwd() {
      this.tableData.forEach(item => {
        item.showPwd = true;
      });
      this.pwdKey = Math.random();
    },
    handleDetail(index, row) {
      this.currentGiftRecord = row;
      this.recordInfoVisible = true;
    },
    // 发放
    handleGive(index, row) {
      this.$refs.giveRef.open(row);
    },
    handleRecycle(index, row) {
      this.$refs.recyclingRef.open(row);
    }
  }
};
</script>
<style lang="scss" scoped>
.table-btns {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .rl {
    display: flex;
    align-items: center;
  }
  .btn {
    margin-left: 10px;
  }
  .rl {
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// record.vue?9d746f36